import { useMediaQuery } from 'react-responsive';
import styles from './healthcare-case2.module.css';
import MultpleLineBottom from '../../public/svg/multple-line-bottom.svg';
import Puzzle from '../../public/healthcare/case2/puzzle.svg';
import PuzzleMobile from '../../public/healthcare/case2/puzzle-mobile.svg';
import Connect from '../../public/svg/connect.svg';
import ConnectMobile from '../../public/svg/connect-mobile.svg';
import LineRight from '../../public/svg/line-right.svg';

import { useMounted } from '../../hooks';
import { Container } from '../../components';
import ProjectCard, { HealthcareProject } from './healthcare-project-card';
import HealthcareDescription from './healthcare-description';
import ProjectCardList from './healthcare-project-list';

const projects: HealthcareProject[] = [
  {
    alt: 'Keto Kitchen image',
    src: '/healthcare/case2/screen1.webp',
    title: 'Home Page',
  },
  {
    alt: 'Keto Kitchen image',
    src: '/healthcare/case2/screen2.webp',
    title: 'Category',
  },
  {
    alt: 'Keto Kitchen image',
    src: '/healthcare/case2/screen3.webp',
    title: 'Filters',
  },
  {
    alt: 'Keto Kitchen image',
    src: '/healthcare/case2/screen4.webp',
    title: 'Recipe Card',
  },
];

export default function HealthcareCase2() {
  const mounted = useMounted();
  const isTablet = useMediaQuery({ maxDeviceWidth: 1023 });

  return (
    <div className={styles.case2}>
      <Container>
        <div className={styles.case2_inner}>
          <HealthcareDescription
            title="Case #2"
            text="Keto Kitchen app provides tasty low carb recipes to diversify your daily menu and make your new healthy lifestyle enjoyable for a long time!."
          />
          {mounted && !isTablet ? (
            <Connect className={styles.case2_connect} />
          ) : (
            <ConnectMobile className={styles.case2_connectMobile} />
          )}
          <h4 className={styles.case2_title}>Keto Kitchen App</h4>
          {mounted && !isTablet ? (
            <img
              alt="line"
              src="/svg/multple-line.svg"
              className={styles.multpleLine}
            />
          ) : (
            <ConnectMobile className={styles.case2_connectMobile} />
          )}
          <ProjectCardList projects={projects} />
          {mounted && !isTablet ? (
            <MultpleLineBottom className={styles.multpleLine} />
          ) : (
            <ConnectMobile className={styles.case2_connectMobile} />
          )}
          <div className={styles.case2_wrapper}>
            <div className={styles.case2_wrapperStart}>
              <ProjectCard
                alt="Keto Kitchen image"
                src="/healthcare/case2/screen5.webp"
              />
            </div>
            <div className={styles.case2_wrapperMiddle}>
              {mounted && !isTablet ? (
                <Puzzle className={styles.case2_puzzle} />
              ) : (
                <PuzzleMobile className={styles.case2_puzzleMobile} />
              )}
            </div>
            <div className={styles.case2_wrapperEnd}>
              <ProjectCard
                alt="Keto Kitchen image"
                src="/healthcare/case2/screen6.webp"
              />
            </div>
          </div>

          {mounted && isTablet && (
            <ConnectMobile className={styles.case2_connectMobile} />
          )}
          <div className={styles.case2_box}>
            {mounted && !isTablet && (
              <LineRight className={styles.case2_lineRgiht} />
            )}

            <a
              className={styles.case2_btn}
              rel="noopener noreferrer"
              target="_blank"
              href="https://ketokitchenapp.com"
            >
              Website
            </a>
          </div>
        </div>
      </Container>
    </div>
  );
}
